export default {
  mutation: {
    overview: 'Détail de la mutation',
    name: 'Mutation',
    search: {},
    list: {
      title: 'Liste des mutations',
      headers: {
        allowedToAccept: 'Autorisé à accepter',
        allowedToCancel: 'Sortante',
        auteurMouvement: 'Auteur du mouvement',
        demandePriseEnChargeBilan: 'Demande prise en charge bilan',
        encours: 'En cours',
        etablissementDestination: 'Etablissement de destination',
        etablissementSource: 'Etablissement source',
        motifMouvement: 'Motif du mouvement',
        participant: 'Participant',
        typeMouvement: 'Type de mouvement',
        date: 'Date',
        bilanEnCours: 'Bilan en cours',
      },
      search: {
        enCours: 'Mutations en cours',
        entrantes: 'Mutations entrantes',
        sortantes: 'Mutations sortantes',
      },
    },
    participant: 'Participant',
    auteurMouvement: 'Auteur du mouvement',
    date: 'Date',
    typeMouvement: 'Type de mouvement',
    motifMouvement: 'Motif du mouvement',
    etablissementSource: "L'établissement source",
    etablissementDestination: "L'établissement de destination",
    accepter: {
      action: 'Accepter la mutation',
      title: 'Acceptation de la mutation',
      message: 'Confirmez-vous que vous souhaitez accepter la mutation ?',
      priseEnChargeBilanEnCours:
        'En acceptant la mutation, votre établissement prendra en charge le bilan en cours du participant',
    },
    annuler: {
      action: 'annuler la mutation',
      title: 'Annuler la mutation',
      message: 'Confirmez-vous que vous souhaitez annuler la mutation ?',
    },
    encours: 'Mutation en cours',
    demande: {
      envoyee: 'La demande de mutation a été envoyée',
      annullee: 'La mutation a été annulée avec succès',
      acceptee: 'La mutation a été acceptée avec succès',
    },
    nonTrouve: "La mutation n'existe pas",
    correspondantNonTrouve: "Le correspondant demandeur n'a pas été trouvé",
    fetch: {
      error: 'Impossible de récupérer la mutation dans Essenciem',
    },
    cancel: {
      error: "Imposible d'annuler une mutation",
    },
    accept: {
      error: "Impossible d'accepter la mutation",
    },
  },
}
